import React from 'react';
import { Link } from 'react-router-dom';
import  Logo from '../../components/Logo/Logo';
const NotFound = () => (
    <>
    <div className="auth-wrapper">
        <div id="container" className="container"> 
            <Logo></Logo>
            <h1 className='mt-3'>Sorry Page is not found.</h1>  
            <Link className='btn btn-outline-light mt-3 mb-4' to="/"> <i className="feather icon-home"></i>Back to Home</Link>  
        </div>
    </div>
    </> 
);

export default NotFound;